import type { Grade, Player } from "../types";

export interface RewardBonus {
  moneyBonus: number;
  xpBonus: number;
}

const FAST_TRIAGE_BONUS = 0.1;

/** Extra urgent-mission bonus granted by Automation Lv3 (0.25 -> 0.35). */
const URGENT_BONUS_EXTRA = 0.1;

/**
 * Fast Triage (skill `automation`) reward bonus, cumulative by level: Lv1 +10%
 * money for grade B and above, Lv2 adds +10% xp for any completed contract.
 * Reputation never gets a bonus; Lv3 raises the urgent-mission bonus instead
 * (see {@link automationUrgentBonus}, audit 2026-09-10).
 */
export function computeRewardBonus(player: Player, grade: Grade): RewardBonus {
  const level = player.skills.automation ?? 0;
  const moneyQualifies = grade === "S" || grade === "A" || grade === "B";
  return {
    moneyBonus: level >= 1 && moneyQualifies ? FAST_TRIAGE_BONUS : 0,
    xpBonus: level >= 2 ? FAST_TRIAGE_BONUS : 0,
  };
}

/** Urgent-mission bonus added on top of the base 25% at Automation Lv3. */
export function automationUrgentBonus(level: number): number {
  return level >= 3 ? URGENT_BONUS_EXTRA : 0;
}
